/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconAccessible = createReactComponent("accessible", "IconAccessible", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M10 16.5l2 -3l2 3m-2 -3v-2l3 -1m-6 0l3 1", key: "svg-1" }],
  [
    "circle",
    { cx: "12", cy: "7.5", r: ".5", fill: "currentColor", key: "svg-2" }
  ]
]);

export { IconAccessible as default };
//# sourceMappingURL=IconAccessible.js.map
